import { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { clsx } from 'clsx'
import { Header } from './Header'
import { Sidebar } from './Sidebar'
import { CicdAccessProvider } from '@/features/management/context/CicdAccessContext'
import { FeatureAccessProvider } from '@/features/authorization/context/FeatureAccessContext'

const sidebarPreferenceKey = 'fs_sidebar_collapsed'

function initialSidebarState() {
  try {
    return window.localStorage.getItem(sidebarPreferenceKey) !== 'false'
  } catch {
    return true
  }
}

export function AppLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(initialSidebarState)
  const [mobileNavigationOpen, setMobileNavigationOpen] = useState(false)

  useEffect(() => {
    try {
      window.localStorage.setItem(
        sidebarPreferenceKey,
        String(sidebarCollapsed),
      )
    } catch {
      // A blocked preference store must not affect navigation.
    }
  }, [sidebarCollapsed])

  return (
    <CicdAccessProvider>
      <FeatureAccessProvider>
        <div className="min-h-screen bg-canvas text-primary">
          <Header onOpenNavigation={() => setMobileNavigationOpen(true)} />
          <Sidebar
            collapsed={sidebarCollapsed}
            mobileOpen={mobileNavigationOpen}
            onCollapsedChange={setSidebarCollapsed}
            onMobileClose={() => setMobileNavigationOpen(false)}
          />
          <main
            className={clsx(
              'min-h-screen pt-16 transition-[padding] duration-300 [--sidebar-width:0rem]',
              sidebarCollapsed
                ? 'lg:pl-16 lg:[--sidebar-width:4rem]'
                : 'lg:pl-56 lg:[--sidebar-width:14rem]',
            )}
          >
            <Outlet />
          </main>
        </div>
      </FeatureAccessProvider>
    </CicdAccessProvider>
  )
}
